import React, { useState } from "react";
import styled from "styled-components";
import DashFooter from "../components/DashFooter";
import { Link } from "react-router-dom";
import DashboardSidebar from "../components/DashboardSidebar";

const Billing = () => {
  const [toggleTab, setToogleTab] = useState(1);
  const tooggleBtn = (index) => {
    setToogleTab(index);
  };
  return (
    <>
      <DashboardSidebar>
        <BillingMain>Billing</BillingMain>
        <BillingToggle>
          <li onClick={() => tooggleBtn(1)}>
            {toggleTab === 1 ? <div className="borderActive"></div> : null}
            <span className={toggleTab === 1 ? "colorActive" : "color"}>
              Overview
            </span>
          </li>
          <li onClick={() => tooggleBtn(2)}>
            {toggleTab === 2 ? <div className="borderActive"></div> : null}
            <span className={toggleTab === 2 ? "colorActive" : "color"}>
              Invoices
            </span>
          </li>
        </BillingToggle>
        <Border></Border>
        {toggleTab === 1 ? (
          <>
            <BillingCard>
              <BillingContainer>
                <BillingGrid>
                  <BillingDiv>
                    <h5>Running Invoice Total</h5>
                    <h4>₹0.00</h4>
                    <div className="grid">
                      <div>
                        <h6>Billing Period</h6>
                        <p>05/01/23 - 06/01/23</p>
                      </div>
                      <div>
                        <h6>Last Billed On</h6>
                        <p>12/01/22</p>
                      </div>
                      <div>
                        <h6>Previous Invoice</h6>
                        <p>$0.00</p>
                      </div>
                      <div>
                        <h6>This Time Last Month</h6>
                        <p>$0.00</p>
                      </div>
                    </div>
                    <Link to="/invoice-detail">
                      <div className="view">View Current Invoice</div>
                    </Link>
                    <BorderRight></BorderRight>
                  </BillingDiv>
                  <BillingDiv>
                    <div className="space_between">
                      <div>
                        <span>Description</span>
                      </div>
                      <div>
                        <span>Running Total</span>
                      </div>
                    </div>
                    <div className="space_between border">
                      <div>
                        <p>App Services</p>
                      </div>
                      <div>
                        <p>$0.00</p>
                      </div>
                    </div>
                  </BillingDiv>
                </BillingGrid>
              </BillingContainer>
            </BillingCard>
            <BillingFlex>
              <PaymentGrid>
                <PaymentCard>
                  <h4>Plan Details</h4>
                  <p>Free</p>
                </PaymentCard>
                <PaymentCard>
                  <h4>Payment Method</h4>
                  <p>Not added yet.</p>
                  <div className="add">ADD PAYMENT METHOD</div>
                </PaymentCard>
              </PaymentGrid>
            </BillingFlex>
          </>
        ) : null}
        {toggleTab === 2 ? (
          <>
            <InvoiceCard>
              <InvoiceGrid className="border">
                <InvoiceDiv>
                  <p>Payment Status</p>
                </InvoiceDiv>
                <InvoiceDiv>
                  <p>Invoice Date</p>
                </InvoiceDiv>
                <InvoiceDiv>
                  <p>Invoice Period</p>
                </InvoiceDiv>
                <InvoiceDiv>
                  <p>Subtotal</p>
                </InvoiceDiv>
                <InvoiceDiv>
                  <p>Download As</p>
                </InvoiceDiv>
              </InvoiceGrid>
            </InvoiceCard>
            <InvoiceCard>
              <InvoiceGrid>
                <InvoiceDiv>
                  <div className="pending">PENDING</div>
                </InvoiceDiv>
                <InvoiceDiv>
                  <h5>06/01/23</h5>
                </InvoiceDiv>
                <InvoiceDiv>
                  <h5>05/01/23-06/01/23</h5>
                </InvoiceDiv>
                <InvoiceDiv>
                  <h5>$0.00</h5>
                </InvoiceDiv>
                <InvoiceDiv>
                  <div className="flex">
                    <button>PDF</button>
                    <button>CSV</button>
                  </div>
                </InvoiceDiv>
              </InvoiceGrid>
            </InvoiceCard>
            <InvoiceCard>
              <InvoiceGrid>
                <InvoiceDiv>
                  <div className="na">N/A</div>
                </InvoiceDiv>
                <InvoiceDiv>
                  <h5>06/01/23</h5>
                </InvoiceDiv>
                <InvoiceDiv>
                  <h5>05/01/23-06/01/23</h5>
                </InvoiceDiv>
                <InvoiceDiv>
                  <h5>$0.00</h5>
                </InvoiceDiv>
                <InvoiceDiv>
                  <div className="flex">
                    <button>PDF</button>
                    <button>CSV</button>
                  </div>
                </InvoiceDiv>
              </InvoiceGrid>
            </InvoiceCard>
            <InvoiceCard>
              <InvoiceGrid>
                <InvoiceDiv>
                  <div className="na">N/A</div>
                </InvoiceDiv>
                <InvoiceDiv>
                  <h5>06/01/23</h5>
                </InvoiceDiv>
                <InvoiceDiv>
                  <h5>05/01/23-06/01/23</h5>
                </InvoiceDiv>
                <InvoiceDiv>
                  <h5>$0.00</h5>
                </InvoiceDiv>
                <InvoiceDiv>
                  <div className="flex">
                    <button>PDF</button>
                    <button>CSV</button>
                  </div>
                </InvoiceDiv>
              </InvoiceGrid>
            </InvoiceCard>
            <InvoiceCard>
              <InvoiceGrid>
                <InvoiceDiv>
                  <div className="na">N/A</div>
                </InvoiceDiv>
                <InvoiceDiv>
                  <h5>06/01/23</h5>
                </InvoiceDiv>
                <InvoiceDiv>
                  <h5>05/01/23-06/01/23</h5>
                </InvoiceDiv>
                <InvoiceDiv>
                  <h5>$0.00</h5>
                </InvoiceDiv>
                <InvoiceDiv>
                  <div className="flex">
                    <button>PDF</button>
                    <button>CSV</button>
                  </div>
                </InvoiceDiv>
              </InvoiceGrid>
            </InvoiceCard>
          </>
        ) : null}
        <DashFooter />
      </DashboardSidebar>
    </>
  );
};

export default Billing;

const BillingMain = styled.h3`
  font-weight: 500;
  font-size: 35px;
  font-family: "Source Serif Pro", serif;
  color: rgb(0, 104, 74);
`;

const BillingToggle = styled.ul`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  li {
    cursor: pointer;
    position: relative;
    list-style: none;
    margin-right: 25px;
    span {
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 500;
      font-size: 17px;
      text-align: center;
      margin-left: 18px;
    }
    margin-top: 20px;
  }

  .colorActive {
    color: rgb(28, 45, 56);
  }
  .color {
    color: #c1c7c6;
  }

  .borderActive {
    position: absolute;
    top: 120%;
    left: 0%;
    background-color: rgb(28, 45, 56);
    height: 3px;
    width: 110px;
  }
`;

const Border = styled.div`
  background-color: #cfcece;
  height: 3px;
  margin-top: 5px;
  width: 100%;
`;

const BillingCard = styled.div`
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #cfcfcf;
  background-color: #fff;
  padding: 20px 15px;
  border-radius: 7px;
  margin-top: 15px;
  width: 85%;
`;

const BillingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

const BillingGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.5fr;
  grid-gap: 1rem;

  @media only screen and (max-width: 991px) {
    grid-template-columns: 1fr;
  }
`;

const BillingDiv = styled.div`
  position: relative;
  h5 {
    font-weight: 600;
    font-size: 14px;
    color: rgb(28, 45, 56);
  }
  h4 {
    font-size: 22px;
    font-weight: 600;
    color: rgb(28, 45, 56);
  }
  .grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 2rem;
    grid-row-gap: 1rem;
    margin-top: 1rem;

    h6 {
      font-weight: 600;
      font-size: 13px;
      color: rgb(28, 45, 56);
    }
    p {
      font-weight: 400;
      font-size: 16px;
      color: rgb(0, 104, 74);
    }

    @media only screen and (max-width: 991px) {
      grid-gap: 1rem;
      p {
        font-size: 14px;
      }
    }
  }
  .view {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
    width: 97.5%;
    text-align: center;
    padding: 5px 10px;
    border: 1px solid rgb(136, 147, 151);
    border-radius: 6px;
    background-color: rgb(249, 251, 250);
    color: rgb(0, 30, 43);
    font-size: 13px;
    line-height: 20px;
    font-weight: 500;
    margin-top: 17px;
    margin-left: -4px;
    cursor: pointer;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .space_between {
    display: flex;
    align-items: center;
    justify-content: space-between;

    div {
      span {
        font-weight: 600;
        font-size: 14px;
        color: rgb(28, 45, 56);
      }
      p {
        font-weight: 600;
        font-size: 14px;
        color: rgb(0, 104, 74);
        padding-bottom: 4px;
        padding-top: 4px;
      }
    }
  }
  .border {
    border-bottom: 1px solid #cfcece;
  }

  @media only screen and (max-width: 991px) {
    .border {
      border: none;
    }
  }
`;

const BorderRight = styled.div`
  position: absolute;
  left: 100%;
  top: 0%;
  background-color: #cfcece;
  height: 100%;
  width: 0.5px;

  @media only screen and (max-width: 991px) {
    display: none;
  }
`;

const BillingFlex = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

const PaymentGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 1rem;

  @media only screen and (max-width: 991px) {
    grid-template-columns: 1fr;
    grid-gap: 0rem;
  }
`;

const PaymentCard = styled.div`
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #cfcfcf;
  background-color: #fff;
  padding: 20px 15px;
  border-radius: 7px;
  margin-top: 20px;
  width: 300px;

  h4 {
    font-weight: 600;
    font-size: 14px;
    color: rgb(28, 45, 56);
  }
  p {
    font-weight: 400;
    font-size: 15px;
    color: rgb(0, 104, 74);
  }
  .add {
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgb(0, 104, 74);
    color: #fff;
    border-radius: 6px;
    margin-top: 8px;
    font-size: 15px;
    padding: 2px 10px;
    cursor: pointer;
    width: 90%;
  }

  @media only screen and (max-width: 991px) {
    margin-top: 10px;
  }
`;

const InvoiceCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  .border {
    border-bottom: 1px solid #cfcece;
  }
`;

const InvoiceGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-gap: 1rem;

  @media only screen and (max-width: 991px) {
    grid-gap: 0.6rem;
  }
`;

const InvoiceDiv = styled.div`
  width: 200px;
  position: relative;

  @media only screen and (max-width: 991px) {
    width: 70px;
  }
  p {
    text-align: left;
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
    margin-bottom: 10px;
    padding-left: 10px;
    padding-top: 2rem;
    color: rgb(28, 45, 56);

    @media only screen and (max-width: 991px) {
      text-align: center;
      font-size: 13px;
      padding-left: 2px;
    }
  }
  h5 {
    margin: 1rem 0rem;
    text-align: left;
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    padding-left: 10px;
    color: rgb(0, 104, 74);

    @media only screen and (max-width: 991px) {
      text-align: center;
      font-size: 13px;
      padding-left: 0px;
    }
  }
  .flex {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 25%;
    left: 8%;

    button {
      border: none;
      outline: none;
      border: 1px solid rgb(28, 45, 56);
      padding: 2px 10px;
      cursor: pointer;

      &:nth-child(1) {
        border-radius: 5px 0px 0px 5px;
      }
      &:nth-child(2) {
        border-left: none;
        border-radius: 0px 5px 5px 0px;
      }
    }

    @media only screen and (max-width: 991px) {
      flex-direction: column;
      position: relative;

      button {
        border: none;
        outline: none;
        border: 1px solid rgb(28, 45, 56);
        padding: 2px 10px;
        cursor: pointer;
        width: 100%;

        &:nth-child(1) {
          border-radius: 0px;
        }
        &:nth-child(2) {
          border-left: 1px solid rgb(28, 45, 56);
          border-radius: 0px;
          border-top: none;
        }
      }
    }
  }
  .pending {
    color: #f54141;
    background-color: #f3ff86;
    width: 50%;
    margin: 1rem 0rem;
    text-align: center;
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    padding-left: 0px;
    padding-top: 3px;
    padding-bottom: 3px;
    border-radius: 6px;

    @media only screen and (max-width: 991px) {
      width: 100%;
    }
  }
  .na {
    color: rgb(0, 104, 74);
    background-color: #fdf0f0;
    width: 30%;
    margin: 1rem 0rem;
    text-align: center;
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    padding-left: 0px;
    padding-top: 3px;
    padding-bottom: 3px;
    border-radius: 6px;
  }
`;
